
export class GetTaskInputDto {
    taskId: string;
}
